import {
  SUBMIT_NEEDS_FAILURE,
  SUBMIT_NEEDS_REQUEST,
  SUBMIT_NEEDS_SUCCESS,
  SELECTED_NEEDS
} from "../actions/needsActions";
const initialState = {
  needs: [],
  loading: false,
  needsSubmited: false,
  needsSubmitedErrorMsg: "",
  needsSubmitedError: false
};

const needsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SELECTED_NEEDS:
      return {
        ...state,
        needs: action.value
      };
    case SUBMIT_NEEDS_REQUEST:
      return {
        ...state,
        loading: true,
        needsSubmited: false,
        needsSubmitedErrorMsg: "",
        needsSubmitedError: false
      };
    case SUBMIT_NEEDS_SUCCESS:
      return {
        ...state,
        loading: false,
        needsSubmited: true,
        needsSubmitedErrorMsg: "",
        needsSubmitedError: false
      };
    case SUBMIT_NEEDS_FAILURE:
      return {
        ...state,
        loading: false,
        needsSubmited: false,
        needsSubmitedError: true,
        needsSubmitedErrorMsg: action.error
      };
    default:
      return state;
  }
};
export default needsReducer;
